import React, { useState, useEffect } from 'react';
import './EditProfileModal.css';
import TopBar from '../TopBar/TopBar';
import { fetchUserProfile, updateUserProfile } from '../../../api/profileServices';
import { UserProfile } from '../../../types/userType';

interface EditProfileModalProps {
  isOpen: boolean;
  onClose: () => void;
  onUpdateComplete: (updatedProfile: UserProfile) => void;
  initialProfile: UserProfile | null;
}

const EditProfileModal: React.FC<EditProfileModalProps> = ({ isOpen, onClose, onUpdateComplete, initialProfile }) => {
  const [profile, setProfile] = useState<UserProfile>({ username: '', email: '', bio: '' });

  useEffect(() => {
    if (isOpen && initialProfile) {
      setProfile(initialProfile);
    }
  }, [isOpen, initialProfile]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    if (name !== 'email') {
      setProfile(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    onClose();
    onUpdateComplete(profile);
    try {
      await updateUserProfile(profile);
    } catch (error) {
      console.error('Failed to update profile:', error);
      // Optionally, you can add error handling here, such as showing a toast message
    }
  };

  if (!isOpen) return null;

  return (
    <div className="edit-profile-modal-overlay">
      <div className="edit-profile-modal-content">
        <TopBar 
          showBackButton={true} 
          showLogo={false} 
          pageName="" 
          onBackClick={onClose} 
        />
        <button className="close-button" onClick={onClose}>Done</button>
        <h2>Edit profile</h2>
        <form className="edit-profile-form" onSubmit={handleSubmit}>
          <div className="info-group">
            <div className="form-group">
              <label className="input-title">Username</label>
              <input
                className={`form-input ${profile.username ? 'input-filled' : ''}`}
                type="text"
                name="username"
                value={profile.username}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label className="input-title">Email</label>
              <input
                className={`form-input ${profile.email ? 'input-filled' : ''}`}
                type="email"
                name="email"
                value={profile.email}
                onChange={handleChange}
                disabled={true}
                style={{ opacity: 0.7, cursor: 'not-allowed' }}
              />
            </div>
            <div className="form-group">
              <label className="input-title">Bio</label>
              <textarea
                className={`form-input ${profile.bio ? 'input-filled' : ''}`}
                name="bio"
                value={profile.bio}
                onChange={handleChange}
              />
            </div>
          </div>
          <button type="submit" className="submit-button">Update</button>
        </form>
      </div>
    </div>
  );
};

export default EditProfileModal;
